import Portal = require("portal-gis");
import Base = require("./base-collection");

class Collection extends Base<Portal.MapLayerLeaf> {
    static about = `Layers`;
}

export = Collection; 